export enum AdminReportType {
  Executive = 'executive',
  Detailed = 'detailed',
  Full = 'full',
}
